import { Grid, CardHeader, CardContent, Box, TextField, CircularProgress, Avatar, MenuItem, Select, FormHelperText } from "@mui/material";
import { apiCategory, sportsTeamServices } from "../../services/AllServices";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import errorHandler from "../../utils/errorHandler";
import { IMAGE_BASE } from "../../utils/constants";
import CardLayout from "../../layouts/CardLayout";

function ViewSportsTeam() {
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [data, setData] = useState();
  const [subcategories, setSubcategories] = useState([]);
  const [Childsubcategories, setSubChildcategories] = useState([]);
  const { id } = useParams();

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await sportsTeamServices.getById({ teamId: id });
        const resData = response?.data?.data;
        setImagePreview(IMAGE_BASE + resData?.image);
        setData(resData);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  const fetchCategoriesData = async (req, res) => {
    try {
      const response = await apiCategory.categorySports({ slug: "sports" });
      setSubcategories(response?.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  }

  useEffect(() => {
    fetchTaskData();
    fetchCategoriesData()
  }, [fetchTaskData]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data?.name || "",
      image: data?.image || "",
      status: data?.status || "active",
      description: data?.description || "",
      categoryId: data?.categoryId || "",
      subcategoryId: data?.subcategoryId || "",
    },
    onSubmit: async (values) => {},
  });

  useEffect(() => {

    const fetchSubCategory = async () => {
      if (data?.categoryId) {
        try {
          const payload = { categoryId: data?.categoryId };
          const response = await apiCategory.category(payload);

          const subcategoriesData = response.data?.data || [];

          setSubChildcategories(subcategoriesData);
        } catch (error) {
          setSubChildcategories([]);
          errorHandler(error);
        }
      }
    };

    fetchSubCategory();
  }, [data?.categoryId]);

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`View Ticket`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Grid container spacing={3}>

                <Grid item xs={12} md={12}>
                  <Box
                    mt={2}
                    onClick={() => fileInputRef.current.click()}
                    className="upload-box"
                  >
                    {imageLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      <Avatar
                        src={imagePreview || "/path/to/default-avatar.jpg"}
                        alt="preview"
                        className="avatar"
                      />
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Team Name"
                    value={formik.values.name || ""}
                    onChange={formik.handleChange}
                    name="name"
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    select
                    fullWidth
                    label="Category"
                    value={formik.values.categoryId}
                    name="categoryId"
                    disabled
                  >
                    <MenuItem value=" " disabled>Select Sub Category</MenuItem>
                    {subcategories?.map((sub, index) => (
                      <MenuItem key={index} value={sub._id}>
                        {sub.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {Childsubcategories.length > 0 ?
                  <Grid item xs={12} md={12}>
                    <TextField
                      select
                      fullWidth
                      label="Sub Category"
                      value={formik.values.subcategoryId}
                      name="subcategoryId"
                      disabled
                    >
                      <MenuItem value="" disabled>Select Sub Category</MenuItem>
                      {Childsubcategories?.map((sub, index) => (
                        <MenuItem key={index} value={sub._id}>
                          {sub.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  : ''}

                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={10}
                    maxRows={10}
                    label="Description"
                    disabled
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    name="description"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    labelId="status-label"
                    id="status"
                    value={formik.values.status}
                    fullWidth
                    disabled
                  >

                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value={"active"}>Active</MenuItem>
                    <MenuItem value={"inactive"}>Inactive</MenuItem>
                  </Select>
                  {formik.touched.status && formik.errors.status && (
                    <FormHelperText error>
                      {formik.errors.status}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default ViewSportsTeam;